import { NarrativeForm } from '../../utils/schema';

export const getValuatorValues = ({
  fairValue,
  discountRatePercentage,
  priceEarningsMultiple,
  profitMarginPercentage,
  revenuePercentage,
  timePeriod,
  futureSharesOutstanding,
  exchangeRate,
}: NarrativeForm) => {
  return {
    fairValue,
    discountRatePercentage,
    priceEarningsMultiple,
    profitMarginPercentage,
    revenuePercentage,
    timePeriod,
    futureSharesOutstanding,
    exchangeRate,
  };
};
export type NarrativeValuatorForm = ReturnType<typeof getValuatorValues>;
